export default {
  Pa: "invalid_api_key",
  Ua: "blacklisted",
  Ha: "no_device_identifier",
  La: "invalid_json_response",
  Ka: "empty_response",
  __: "sdk_auth_error",
};
